import { SourceType, isDefined } from '@aloft/toolkit-shared';

import { FieldPath, UseFormGetValues } from 'react-hook-form';

import { PropertyGridFieldName, PropertyGridForm } from '../../types.ts';
import { SourceOption } from './types.ts';

type UseSourceOptionsParams = {
  columns: PropertyGridForm['columns'];
  propertyId: string;
  fieldName: PropertyGridFieldName;
  toDisplayValue?: (value: string | undefined, propertyId: string) => string | undefined;
  getValues: UseFormGetValues<PropertyGridForm>;
};

export const useSourceOptions = ({
  columns,
  propertyId,
  fieldName,
  toDisplayValue,
  getValues,
}: UseSourceOptionsParams): SourceOption[] =>
  columns
    .filter((column) => column?.propertyId === propertyId && column?.type !== 'property')
    .map(({ type: source }) => {
      const dataSourceColumnIndex = columns.findIndex(
        (column) => column?.propertyId === propertyId && column?.type === source,
      );

      if (dataSourceColumnIndex === -1) return undefined;

      const optionValue = getValues(
        `columns.${dataSourceColumnIndex}.propertyData.${fieldName}` as FieldPath<PropertyGridForm>,
      ) as string | undefined;

      if (!source) return undefined;

      return {
        value: toDisplayValue ? toDisplayValue(optionValue, propertyId) : optionValue,
        source: source as SourceType,
      };
    })
    .filter(isDefined);
